/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Export a single profile's evaluation (criteria + reasoning + evidence).
 */
export interface ArbitratorEvaluationExportSourceSchema {
  type?: 'arbitrator_evaluation';
  session_id: string;
  profile_id: string;
}
